import { APIModel } from "./api-model";

export class NonRecovery extends APIModel {
  id: string;
  code: string;

  static fieldsToMap = {
    direct: [
      'code'
    ]
  }

  static buildFromAPI(record: any): NonRecovery {
    const row = new NonRecovery();
    record = record || {};

    this.mapFieldsDirectly<NonRecovery>(NonRecovery.fieldsToMap.direct, record, row);

    return row
  }
}